import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiInterceptor, AuthenticationInterceptor, ConvertDateInterceptor } from './interceptor';

export const HttpInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthenticationInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ApiInterceptor,
    multi: true,
  },

  {
    provide: HTTP_INTERCEPTORS,
    useClass: ConvertDateInterceptor,
    multi: true,
  },
];
